import React, { useState, useEffect } from "react";
import moment from "moment";
import { IconSettings, Datepicker } from "@salesforce/design-system-react";

const CustomDatepicker = ({ id, label, value, onChange }) => {
  return (
    <div className="slds-p-top_x-small form-item">
      <IconSettings iconPath="/icons">
        <Datepicker
          id={id}
          labels={{
            label: label,
          }}
          onChange={onChange}
          formatter={(date) => {
            return date && date != "Invalid Date"
              ? moment(date).format("M/D/YYYY")
              : "";
          }}
          parser={(dateString) => {
            return moment(dateString, "MM-DD-YYYY").toDate();
          }}
          value={value}
        />
      </IconSettings>
    </div>
  );
};

CustomDatepicker.defaultProps = {
  id: "datepicker-1",
  label: "REPLACE-datepicker-label",
  value: moment().format("M/D/YYYY"),
  onUpdate: () => console.log("ATTACH FORM UPDATE FUNCTION"),
};

export default CustomDatepicker;
